.priceFlex {
  justify-content: center;
}

.grid {
  grid-template-columns: repeat(3, 1fr);
}

.option {
  height: 112px;
  padding: 24px 12px;
}

@media (--reefer-media-tablet-max) {
  .priceFlex {
    justify-content: flex-start;
  }

  .grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .option {
    height: 104px;
  }
}
